import { getEmploiInformationProgramsSaga } from './getEmploiInformationPrograms'
import { getEmploiInformationInscritesSaga } from './getEmploiInformationInscrites'
import { getEmploiInformationInscriptionSaga } from './getEmploiInformationInscription'

const DonneesEmploiSagas = [
    getEmploiInformationProgramsSaga,
    getEmploiInformationInscritesSaga,
    getEmploiInformationInscriptionSaga,
]

export default DonneesEmploiSagas
